import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'sto_index',
      component: () => import('./views/Sto/index/index.vue' /* webpackChunkName: "index" */),
    },
    {
      path: '/inventory/list',
      name: 'sto_inventory_list',
      component: () => import('./views/Sto/inventory/list.vue'),
    },
    {
      path: '/inventory/info/:id',
      name: 'sto_inventory_info',
      component: () => import('./views/Sto/inventory/info.vue'),
    },
    {
      path: '/inventory/info/:id/:flag',
      component: () => import('./views/Sto/inventory/info.vue'),
    },
		{
		  path: '/inventorylog/list',
		  component: () => import('./views/Sto/inventorylog/list.vue'),
		},
    {
      path: '/inventoryMgt',
      component: () => import('./views/Sto/inventoryMgt/index.vue'),
    },
    // 库存成本
    {
      path: '/inventoryCost',
      component: () => import('./views/Sto/inventoryCost/index.vue'),
    },
    {
      path: '/inventoryAsset',
      component: () => import('./views/Sto/inventoryAsset/index.vue'),
    },
    {
      path: '/purchase/list/:status?/:orderId?',
      name: 'sto_purchase_list',
      component: () => import('./views/Sto/purchase/list.vue'),
    },
    {
      path: '/purchase/add',
      name: 'sto_purchase_add',
      component: () => import('./views/Sto/purchase/add.vue'),
    },
    {
      path: '/purchase/edit/:id',
      name: 'sto_purchase_edit',
      component: () => import('./views/Sto/purchase/edit.vue'),
    },
    {
      path: '/purchase/approveDetail/:id',
      name: 'sto_approve_etail',
      component: () => import('./views/Sto/purchase/approve-detail.vue'),
    },
    {
      path: '/purchase/info/:id',
      name: 'sto_purchase_info',
      component: () => import('./views/Sto/purchase/info.vue'),
    },
    {
      path: '/purchase/info/:id/:flag',
      component: () => import('./views/Sto/purchase/info.vue'),
    },
    {
      path: '/purchase/enterStore/:id',
      name: 'sto_enter_store',
      component: () => import('./views/Sto/purchase/enter-store.vue'),
    },

    {
      path: '/purchasec/list',
      name: 'sto_purchasec_list',
      component: () => import('./views/Sto/purchasec/list.vue'),
    },
    {
      path: '/purchasec/info/:id',
      name: 'sto_purchasec_info',
      component: () => import('./views/Sto/purchasec/info.vue'),
    },

    {
      path: '/transfer/list/:orderId?',
      name: 'sto_transfer_list',
      component: () => import('./views/Sto/transfer/list.vue'),
    },
    {
      path: '/transfer/info/:id',
      name: 'sto_transfer_info',
      component: () => import('./views/Sto/transfer/info.vue'),
    },
    {
      path: '/transfer/info/:id/:flag',
      component: () => import('./views/Sto/transfer/info.vue'),
    },
    {
      path: '/transfer/receive/:id',
      component: () => import('./views/Sto/transfer/receive.vue'),
    },

    {
      path: '/transfero/list',
      name: 'sto_transfero_list',
      component: () => import('./views/Sto/transfero/list.vue'),
    },
    {
      path: '/transfero/info/:id',
      name: 'sto_transfero_info',
      component: () => import('./views/Sto/transfero/info.vue'),
    },

    {
      path: '/process/list',
      name: 'sto_process_list',
      component: () => import('./views/Sto/process/list.vue'),
    },
    {
      path: '/process/info/:id/',
      name: 'sto_process_info',
      component: () => import('./views/Sto/process/info.vue'),
    },
    {
      path: '/process/info/:id/:flag',
      component: () => import('./views/Sto/process/info.vue'),
    },
    // {
    //   path: "/process/main/:id",
    //   component: () => import("./views/Sto/process/main.vue"),
    // },

    {
      path: '/processc/list',
      name: 'sto_processc_list',
      component: () => import('./views/Sto/processc/list.vue'),
    },

    {
      path: '/disassembly/list',
      name: 'sto_disassembly_list',
      component: () => import('./views/Sto/disassembly/list.vue'),
    },
    {
      path: '/disassembly/info/:id',
      name: 'sto_disassembly_info',
      component: () => import('./views/Sto/disassembly/info.vue'),
    },
    {
      path: '/disassembly/info/:id/:flag',
      component: () => import('./views/Sto/disassembly/info.vue'),
    },
    {
      path: '/disassembly/main/:id',
      name: 'sto_disassembly_main',
      component: () => import('./views/Sto/disassembly/main.vue'),
    },

    {
      path: '/disassemblyc/list',
      name: 'sto_disassemblyc_list',
      component: () => import('./views/Sto/disassemblyc/list.vue'),
    },
    // 销售 using
    {
      path: '/sale/list/:mode/:type',
      name: 'sto_sale_list',
      component: () => import('./views/Sto/sale/list.vue'),
    },
		{
		  path: '/sale/add/:id?',
		  name: 'sto_sale_add',
		  component: () => import('./views/Sto/sale/add.vue'),
		},
    {
      path: '/sale/info/:id',
      name: 'sto_sale_info',
      component: () => import('./views/Sto/sale/info.vue'),
    },
		{
		  path: '/sale/outstock',
		  name: 'sto_sale_outstock',
		  component: () => import('./views/Sto/sale/static.vue'),
		},
    // 租凭订单统计
    {
      path: '/leasecmp',
      name: 'leasecmp',
      component: () => import('./views/Sto/leasecmp/index.vue'),
    },
    // 销售订单统计
    {
      path: '/salecmp',
      name: 'sto_salecmp',
      component: () => import('./views/Sto/salecmp/index.vue'),
    },
    // index
    { path: '/index', component: () => import('./views/Sto/index/index.vue') },
    // 销售出库
    {
      path: '/saleo/list',
      name: 'sto_saleo_list',
      component: () => import('./views/Sto/saleo/list.vue'),
    },
    {
      path: '/saleo/info/:id',
      name: 'sto_saleo_info',
      component: () => import('./views/Sto/saleo/info.vue'),
    },
		// 出库
		{
		  path: '/saleo/out/:id',
		  name: 'sto_saleo_out',
		  component: () => import('./views/Sto/saleo/out.vue'),
		},
		// 发货
		{
		  path: '/saleo/send/:id',
		  name: 'sto_saleo_send',
		  component: () => import('./views/Sto/saleo/send.vue'),
		},
		// 详情
		{
		  path: '/saleo/detail/:id',
		  name: 'sto_saleo_detail',
		  component: () => import('./views/Sto/saleo/detail.vue'),
		},
		// 发货记录
		{
		  path: '/saleo/sendlogdetail/:id',
		  name: 'sto_saleo_detail_sendlog',
		  component: () => import('./views/Sto/saleo/components/sendlog.vue'),
		},
		// 出库记录 详情
		{
		  path: '/saleo/outlogdetail/:id',
		  name: 'sto_saleo_detail_outlog',
		  component: () => import('./views/Sto/saleo/components/outlog.vue'),
		},
		// 发货记录 页面
		{
		  path: '/saleo/sendlog/:mode',
		  name: 'sto_saleo_sendlog',
		  component: () => import('./views/Sto/saleo/sendlog.vue'),
		},
		// 出库记录 页面
		{
		  path: '/saleo/outlog/:mode',
		  name: 'sto_saleo_outlog',
		  component: () => import('./views/Sto/saleo/outlog.vue'),
		},
		// 入库记录 页面
		{
		  path: '/purchase/enterlog',
		  name: 'sto_purchase_outlog',
		  component: () => import('./views/Sto/purchase/enterlog'),
		},
    // 仓库管理 物料出库
    {
      path: '/material/list',
      component: () => import('./views/Sto/material/list.vue'),
    },
    // 仓库管理 签收
    {
      path: '/receive/list',
      component: () => import('./views/Sto/receive/list.vue'),
    },
    {
      path: '/receive/info/:type/:id',
      component: () => import('./views/Sto/receive/info.vue'),
    },
    // 我的销售单
    {
      path: '/shopping/list',
      component: () => import('./views/Sto/shopping/list.vue'),
    },
    {
      path: '/shopping/info/:id',
      component: () => import('./views/Sto/shopping/info.vue'),
    },
    {
      path: '/workorder/list/:code',
      component: () => import('./views/Sto/workOrder/list.vue'),
    },
    {
      path: '/workorder/info/:code',
      component: () => import('./views/Sto/workOrder/info.vue'),
    },
    // 供应商统计
    {
      path: '/dataReport/supplier',
      component: () => import('./views/Sto/dataReport/supplier/index.vue'),
    },
    {
      path: '/dataReport/supplier/info/:id',
      component: () => import('./views/Sto/dataReport/supplier/info.vue'),
    },
    // 客户统计
    {
      path: '/dataReport/customer',
      component: () => import('./views/Sto/dataReport/customer/index.vue'),
    },
    {
      path: '/dataReport/customer/info/:id',
      component: () => import('./views/Sto/dataReport/customer/info.vue'),
    },

    // 采购员统计
    {
      path: '/dataReport/buyer',
      component: () => import('./views/Sto/dataReport/buyer/index.vue'),
    },
    {
      path: '/dataReport/buyer/info/:id/:name?',
      component: () => import('./views/Sto/dataReport/buyer/info.vue'),
    },

    // 销售团队
    {
      path: '/dataReport/sale',
      component: () => import('./views/Sto/dataReport/sale/team.vue'),
    },
    {
      path: '/dataReport/sale/:team',
      component: () => import('./views/Sto/dataReport/sale/teamInfo.vue'),
    },
    {
      path: '/dataReport/sale/member/:id/:name?',
      component: () => import('./views/Sto/dataReport/sale/memberInfo.vue'),
    },
    {
      path: '/payroll',
      component: () => import('./views/Sto/payroll/index.vue'),
    },
    {
      path: '/payroll/:id',
      component: () => import('./views/Sto/payroll/info.vue'),
    },
    {
      path: '/skuPurchaseList',
      component: () => import('./views/Sto/skuPurchaseList/index.vue'),
    },
    {
      path: '/skuSalesList',
      component: () => import('./views/Sto/skuSalesList/index.vue'),
    },
    {
      path: '/leaseReport/customer',
      component: () => import('./views/Sto/leaseReport/customer/index.vue'),
    },
    {
      path: '/leaseReport/customer/info/:id',
      component: () => import('./views/Sto/leaseReport/customer/info.vue'),
    },
    {
      path: '/leaseReport/lease',
      component: () => import('./views/Sto/leaseReport/lease/team.vue'),
    },
    {
      path: '/leaseReport/lease/:team',
      component: () => import('./views/Sto/leaseReport/lease/teamInfo.vue'),
    },
    {
      path: '/leaseReport/lease/member/:id/:name?',
      component: () => import('./views/Sto/leaseReport/lease/memberInfo.vue'),
    },
    {
      path: '/order/orderinfo',
      component: () => import('./views/Sto/orderInfo/index.vue'),
    },
		{
		  path: '/customer/list',
		  component: () => import('./views/Sto/customer/list.vue'),
		},
		{
		  path: '/customer/verifyorder',
		  component: () => import('./views/Sto/customer/verifyOrder.vue'),
		},
		{
		  path: '/customer/save',
		  component: () => import('./views/Sto/customer/save.vue'),
		},
		{
		  path: '/supplier/verify',
		  component: () => import('./views/Sto/supplier/verify.vue'),
		},
		{
		  path: '/supplier/list',
		  component: () => import('./views/Sto/supplier/list.vue'),
		},
		{
		  path: '/supplier/save',
		  component: () => import('./views/Sto/supplier/save.vue'),
		},
		{
		  path: '/incomeorder/list',
		  component: () => import('./views/Sto/incomeorder/list.vue'),
		},
		{
		  path: '/incomeorder/save/:id',
		  component: () => import('./views/Sto/incomeorder/save.vue'),
		},
		{
		  path: '/incomeorder/receipt/:id',
		  component: () => import('./views/Sto/incomeorder/receipt.vue'),
		},
		{
		  path: '/payorder/list',
		  component: () => import('./views/Sto/payorder/list.vue'),
		},
		{
		  path: '/payorder/save',
		  component: () => import('./views/Sto/payorder/save.vue'),
		},
		{
		  path: '/payorder/pay',
		  component: () => import('./views/Sto/payorder/pay.vue'),
		},
		{
		  path: '/exchange/list',
		  component: () => import('./views/Sto/exchange/list.vue'),
		},
		{
		  path: '/exchange/save',
		  component: () => import('./views/Sto/exchange/save.vue'),
		},
		{
		  path: '/sku/list',
		  component: () => import('./views/Sto/sku/list.vue'),
		},
		{
		  path: '/sku/save',
		  component: () => import('./views/Sto/sku/save.vue'),
		},
		{
		  path: '/transfern/list',
		  component: () => import('./views/Sto/transfern/list.vue'),
		},
		{
		  path: '/transfern/save',
		  component: () => import('./views/Sto/transfern/save.vue'),
		},
		{
		  path: '/transfern/out',
		  component: () => import('./views/Sto/transfern/out.vue'),
		},
		
		
		/* -----------------------工具页面------------------------*/
		// pdf
		{
      path: '/pdf/:url',
      component: () => import('@/components/pdf.vue'),
    },
		{
		  path: '/common/approveDetail/:type',
		  name: 'sto_approve_etail',
		  component: () => import('./views/Sto/common/approve-detail.vue'),
		},
		{
		  path: '/common/approveData/:id',
		  name: 'sto_approve_data',
		  component: () => import('./views/Sto/common/approve-data.vue'),
		},
		{
		  path: '/quotation/index/:id',
		  name: 'quotation',
		  component: () => import('./views/Sto/quotation/index.vue'),
		},

    /* --------------------test------------------------------- */

  ],
})
